import { useRouter } from 'next/router';

import useTranslation from 'hooks/use-translation';
import { useMarketplaceGenericCategoryRoutes } from 'shop/hooks/categories/use-marketplace-generic-category-routes';

import { getGenericCategoryRouteInfo } from 'src/shop/utils/categories';
import { getPathToShopMarketplaceCategory } from 'utils/helpers/route';

import { CategoryLink, UseCategoryLinksReturn } from './use-category-links.types';

export function useMarketplaceCategoryLinks(): UseCategoryLinksReturn {
  const { t } = useTranslation();
  const { asPath } = useRouter();

  const { categories, loading } = useMarketplaceGenericCategoryRoutes();

  const categoryLinks = categories.map(
    (category): CategoryLink => {
      const {
        translation: [transKey, transDefault],
        imgSrc,
      } = getGenericCategoryRouteInfo(category);

      const label = t(transKey, transDefault);
      const href = getPathToShopMarketplaceCategory(category);
      const isActive = asPath.includes(href);

      return { label, href, isActive, imgSrc };
    }
  );

  return {
    categoryLinks,
    loading,
  };
}
